
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"60","height":"60","fill":"none","viewBox":"0 0 60 60"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2","d":"M29.96 18.434c-.78 0-2.75 4.44-2.75 6.14 0 1.52 1.23 2.75 2.75 2.75s2.75-1.23 2.75-2.75c0-1.7-1.97-6.14-2.75-6.14z"}}),_c('path',{attrs:{"stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2","d":"M46.61 29.464c-.59-.49-.85.55-3.3.51-1.02-.01-1.22-.29-1.18-.54.04-.23.05-.42 1.12-.4 2.18.03 3.13-.92 3.77-1.85.64-.94 2.11-2.94.3-5.54-1.81-2.6-3.52-1.85-3.94-3.58-.43-1.73.92-3 0-6.29-.92-3.28-2.62-4.2-3.98-4.62-1.36-.42-2.98.11-4.33.87-1.34.77-1.66 2.98-1.51 4.54.15 1.56 1.04 3.41 1.04 4.26 0 .59-.31 1.34-.73 1.94.08.17.16.34.24.52.39.88 1.67 3.91 1.67 5.94a5.807 5.807 0 01-5.8 5.8c-.7 0-1.38-.13-2-.36-2.21-.82-3.8-2.94-3.8-5.44 0-2.04 1.28-5.06 1.67-5.94.08-.18.16-.35.24-.52-.42-.59-.73-1.34-.73-1.94 0-.85.9-2.71 1.04-4.26.15-1.56-.17-3.77-1.51-4.54s-2.96-1.3-4.33-.87c-1.37.43-3.07 1.34-3.98 4.62-.92 3.28.43 4.56 0 6.29-.43 1.73-2.13.98-3.94 3.58s-.34 4.6.3 5.54c.64.94 1.59 1.89 3.77 1.85 1.07-.02 1.07.17 1.12.4.04.24-.16.52-1.18.54-2.45.03-2.72-1-3.3-.51-.59.49-3.33 2.69-3.35 6.02-.02 3.32 2.88 4.88 3.22 5.09.34.21 1.51 1.17 4.09.79 1.27-.19 1.69-.4 1.83-.01.16.46-.36.67-1.59.89-2.43.43-3.18-.64-3.32.64-.15 1.28-.47 9.21 6.78 9.21s7.1-7.65 6.8-9.5c-.3-1.85-3.27-6.52 2.2-9.38 5.47 2.86 2.5 7.52 2.2 9.38-.3 1.85-.45 9.5 6.8 9.5s6.93-7.93 6.78-9.21c-.15-1.28-.9-.21-3.32-.64-1.23-.22-1.76-.42-1.59-.89.14-.39.56-.18 1.83.01 2.58.38 3.75-.58 4.09-.79.34-.21 3.24-1.77 3.22-5.09-.02-3.32-2.76-5.53-3.35-6.02h-.06z"}})])
          )
        }
      }
    